import { Component, OnInit } from '@angular/core';
import { currency } from 'app/constants/currency.constants';
import { itemTypeLabel } from 'app/constants/itemType.constants';
import { CalculationService, HTTPService, HelperService } from 'app/services';
import { find, subtract, sum } from 'lodash';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-addon-service-dialog',
  templateUrl: './addon-service-dialog.component.html',
  styleUrls: ['./addon-service-dialog.component.scss'],
})
export class AddonServiceDialogComponent implements OnInit {
  primaryServiceName: string = '';
  addOnName: string = '';

  constructor(
    private dialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef
  ) {}

  ngOnInit() {
    const { addOnName, primaryServiceName } = this.dialogConfig.data;

    this.addOnName = addOnName;
    this.primaryServiceName = primaryServiceName;
  }

  handleClose() {
    this.dynamicDialogRef.close({ isSuccess: false });
  }
  
  handleConfirm() {
    this.dynamicDialogRef.close({ isSuccess: true });
  }
}
